import Utils from '@/common/utils/utils';
import { Tooltip } from '@material-ui/core';
import { I18n } from 'aws-amplify';


export default function FooterEmailTicket({
    detailTicket,
    formDetail,
    currentEmailTicket
}) {
    return (
        <div className="detail-ticketKnowledge-info">
            <div className="detailTicket-footer">
                <div className="detail-ticketKnowledge-form">
                    フォーマット：
                    <span>{detailTicket?.usingFormName}</span>
                </div>
                <div className="detail-ticketKnowledge-info-child">
                    <div className="detail-ticketKnowledge-form">
                        {I18n.get('CM-LABEL-FORMAT-ID')} :
                        <span
                            className="id-detail-ticket-copy"
                            onClick={async () => {
                                navigator.clipboard
                                    .writeText(formDetail?.id)
                                    .then(() => {})
                                    .catch(err => {});
                            }}
                        >
                            <img src="/assets/image/icon-copy.svg" alt="" />
                        </span>
                        <span className="field-form-id">{formDetail?.id}</span>
                    </div>
                </div>
                <div className="detail-ticketKnowledge-info-child">
                    <div className="detail-ticketKnowledge-info-time">
                        投稿日時：<span>{Utils.getDateTimeByFormatYYYYMMDDHHMM(detailTicket?.createdAt)}</span>
                    </div>
                    <div className="detail-ticketKnowledge-info-user">
                        投稿ユーザー：
                        <Tooltip title={detailTicket?.createrUserName}>
                            <span
                                style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    width: '55px'
                                }}
                            >
                                {detailTicket?.createrUserName}
                            </span>
                        </Tooltip>
                    </div>
                </div>

                <div className="detail-ticketKnowledge-info-child">
                    <div className="detail-ticketKnowledge-info-time">
                        更新日時：
                        <span>
                        {Utils.getDateTimeByFormatYYYYMMDDHHMM(detailTicket?.updatedAt)}
                        </span>
                    </div>
                    <div className="detail-ticketKnowledge-info-user">
                        更新ユーザー：
                        <Tooltip title={detailTicket?.updatorUserName}>
                            <span
                                style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    width: '55px'
                                }}
                            >
                                {detailTicket?.updatorUserName}
                            </span>
                        </Tooltip>
                    </div>
                </div>
                <div className="id-detail-ticket-footer">
                    <span className='id-detail-ticket-title'>{I18n.get('USER04LB004')} :</span>
                    <span 
                        className="id-detail-ticket-copy" 
                        onClick={ async () => {
                            navigator.clipboard.writeText(detailTicket?.id)
                            .then(() => {})
                            .catch((e) => console.log('copy ticketId e :>> ', e));
                        }}
                    >
                        <img src="/assets/image/icon-copy.svg" alt=""/>
                    </span>
                    <span id="ticketId">{detailTicket?.id}</span>
                </div>
            </div>
        </div>
    );
}
